import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { Pagination, Navigation, Scrollbar } from 'swiper/modules';
import {MIN_DESKTOP, MIN_TABLET} from "../constants";

export default () => ({
    swiper: null,
    init() {
        const options = {
            modules: [Pagination, Navigation, Scrollbar],
            loop: false,
            slidesPerView: 1.15,
            spaceBetween: 30,
            pagination: {
                el: this.$refs.pagination,
                type: "fraction",
            },
            navigation: {
                enabled: true,
                nextEl: this.$refs.nextEl,
                prevEl: this.$refs.prevEl,
            },
            scrollbar: {
                el: this.$refs.sliderScrollbar,
                hide: false
            },
            breakpoints: {}
        };
        options.breakpoints[MIN_TABLET] = {
            slidesPerView: 1.6,
            spaceBetween: 30
        };
        options.breakpoints[MIN_DESKTOP] = {
            slidesPerView: 3,
            spaceBetween: 30
        };
        this.swiper = new Swiper(this.$refs.swiper, options);
    }
});